var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainer1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504.986 504.986",
    style: {
      enableBackground: "new 0 0 504.986 504.986"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.055,
    y: 266.521,
    style: {
      fill: "#FFFFFF"
    },
    width: 332.449,
    height: 210.411
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.482,
    y: 28.055,
    style: {
      fill: "#FFFFFF"
    },
    width: 332.449,
    height: 210.411
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M490.959,0H130.455c-7.715,0-14.027,6.312-14.027,14.027v224.438h-102.4 C6.312,238.466,0,244.778,0,252.493v238.466c0,7.715,6.312,14.027,14.027,14.027h360.504c7.715,0,14.027-6.312,14.027-14.027 V266.521h102.4c7.715,0,14.027-6.312,14.027-14.027V14.027C504.986,6.312,498.674,0,490.959,0z M476.932,238.466H144.482V28.055 h332.449V238.466z M360.504,476.932H28.055V266.521h332.449V476.932z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.11,
    y: 294.575,
    style: {
      fill: "#FFC10D"
    },
    width: 276.34,
    height: 154.301
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.537,
    y: 56.11,
    style: {
      fill: "#56ACE0"
    },
    width: 276.34,
    height: 154.301
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M77.852,291.068c-7.715,0-14.027,6.312-14.027,14.027v133.26c0,7.715,6.312,14.027,14.027,14.027 s14.027-6.312,14.027-14.027v-133.26C91.879,297.381,85.567,291.068,77.852,291.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M122.038,305.096v133.26c0,7.715,6.312,14.027,14.027,14.027s14.027-6.312,14.027-14.027v-133.26 c0-7.715-6.312-14.027-14.027-14.027S122.038,297.381,122.038,305.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M194.279,452.384c7.715,0,14.027-6.312,14.027-14.027v-133.26c0-7.715-6.312-14.027-14.027-14.027 c-7.715,0-14.027,6.312-14.027,14.027v133.26C180.252,446.071,186.564,452.384,194.279,452.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M252.493,452.384c7.715,0,14.027-6.312,14.027-14.027v-133.26c0-7.715-6.312-14.027-14.027-14.027 c-7.715,0-14.027,6.312-14.027,14.027v133.26C238.466,446.071,244.778,452.384,252.493,452.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M310.707,452.384c7.715,0,14.027-6.312,14.027-14.027v-133.26c0-7.715-6.312-14.027-14.027-14.027 s-14.027,6.312-14.027,14.027v133.26C296.679,446.071,302.992,452.384,310.707,452.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M194.279,213.918c7.715,0,14.027-6.312,14.027-14.027V66.63c0-7.715-6.312-14.027-14.027-14.027 c-7.715,0-14.027,6.312-14.027,14.027v133.26C180.252,207.605,186.564,213.918,194.279,213.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M252.493,213.918c7.715,0,14.027-6.312,14.027-14.027V66.63c0-7.715-6.312-14.027-14.027-14.027 c-7.715,0-14.027,6.312-14.027,14.027v133.26C238.466,207.605,244.778,213.918,252.493,213.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M310.707,213.918c7.715,0,14.027-6.312,14.027-14.027V66.63c0-7.715-6.312-14.027-14.027-14.027 s-14.027,6.312-14.027,14.027v133.26C296.679,207.605,302.992,213.918,310.707,213.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M368.921,213.918c7.715,0,14.027-6.312,14.027-14.027V66.63c0-7.715-6.312-14.027-14.027-14.027 s-14.027,6.312-14.027,14.027v133.26C354.893,207.605,361.205,213.918,368.921,213.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M427.134,213.918c7.715,0,14.027-6.312,14.027-14.027V66.63c0-7.715-6.312-14.027-14.027-14.027 s-14.027,6.312-14.027,14.027v133.26C413.107,207.605,419.419,213.918,427.134,213.918z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer1);
export default __webpack_public_path__ + "static/media/container1.aec09d74ca8134612948b02a32849469.svg";
export { ForwardRef as ReactComponent };